import CodeEditor from '../Library/CodeEditor';

export const dispatchPreviewOnRestore = () => {
    document.querySelectorAll('.template-editor input[name=orderId]').forEach(input => {
        if (input.value.trim() === '') {
            return;
        }

        const target = input.closest('.template-editor');

        target?.dispatchEvent(new Event('preview:run'));
    });
};

export const syncPreviewErrorLine = root => {
    if (!root || typeof root.matches !== 'function') {
        return;
    }

    const selector = '.email-template-preview, .document-preview';
    const previews  = root.matches(selector) ? [root] : root.querySelectorAll?.(selector) ?? [];

    for (const preview of previews) {
        const templateEditor = preview.closest('.template-editor');
        const textarea       = templateEditor?.querySelector('textarea[data-line-numbers]');
        const editor         = textarea ? CodeEditor.get(textarea) : null;

        if (!editor) {
            continue;
        }

        const errorEl = preview.querySelector('[data-error-line]');
        const line    = errorEl ? parseInt(errorEl.dataset.errorLine, 10) : null;

        editor.setErrorLine(Number.isFinite(line) ? line : null);
    }
};

const hasOpenTwigDelimiter = content => {
    const pairs = [[/\{\{/g, /\}\}/g], [/\{%/g, /%\}/g], [/\{#/g, /#\}/g]];

    return pairs.some(([open, close]) =>
        (content.match(open) ?? []).length !== (content.match(close) ?? []).length);
};

const caretInsideTwigStatement = (content, caret) => {
    const before    = content.slice(0, caret);
    const lastOpen  = Math.max(before.lastIndexOf('{{'), before.lastIndexOf('{%'), before.lastIndexOf('{#'));
    const lastClose = Math.max(before.lastIndexOf('}}'), before.lastIndexOf('%}'), before.lastIndexOf('#}'));

    return lastOpen > lastClose;
};

const previewShouldWait = (content, caret) =>
    hasOpenTwigDelimiter(content) || caretInsideTwigStatement(content, caret);

export const gatePreviewRequest = event => {
    const element = event.detail.elt;

    if (!element?.matches?.('.template-editor')) {
        return;
    }

    const textarea = element.querySelector('textarea[name=content]');

    if (textarea) {
        const editor = CodeEditor.get(textarea);
        const value  = editor ? editor.value : textarea.value;
        const caret  = editor ? editor.getSelection().start : (textarea.selectionStart ?? value.length);

        if (previewShouldWait(value, caret)) {
            event.preventDefault();

            return;
        }
    }

    const subject = element.querySelector('input[name=subject]');

    if (subject && previewShouldWait(subject.value, subject.selectionStart ?? subject.value.length)) {
        event.preventDefault();
    }
};

const previewFieldUnderCaret = () => {
    const active         = document.activeElement;
    const templateEditor = active?.closest?.('.template-editor');

    if (!templateEditor) {
        return null;
    }

    if (active.matches?.('input[name=subject]')) {
        return {templateEditor, value: active.value, caret: active.selectionStart ?? active.value.length};
    }

    if (active.closest?.('.cm-editor')) {
        const textarea = templateEditor.querySelector('textarea[name=content]');
        const editor   = textarea ? CodeEditor.get(textarea) : null;

        if (editor) {
            return {templateEditor, value: editor.value, caret: editor.getSelection().start};
        }
    }

    return null;
};

let previewCaretWasInsideStatement = false;

export const syncCaretPreview = () => {
    const field = previewFieldUnderCaret();

    if (!field) {
        previewCaretWasInsideStatement = false;

        return;
    }

    const nowInside = caretInsideTwigStatement(field.value, field.caret);

    if (previewCaretWasInsideStatement && !nowInside) {
        field.templateEditor.dispatchEvent(new Event('preview:run'));
    }

    previewCaretWasInsideStatement = nowInside;
};
